<template lang="html">
  <div>
    <div class="top-bar">
      <span @click="goBack"><i class="left"></i></span>
      <span class="heading_new">Class A  Salary Structure</span>
    </div>
    <div class="inner">
      <data-table
          :columns="columnNames"
          :tableData="componentsData"
          :checkbox="false"
          :withForm="true"
          @editStart="initEditStart"
          @delete="deleteItem" />
      <bottom-action-container>
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="goBack" />
          <btn text="Save & continue" type="primary" @click="save" />
        </btn-grp>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columnNames: [{
        label: 'Sr No.',
        key: 'num'
      },
      {
        label: 'Component',
        key: 'componentName'
      },
      {
        label: 'Calculations(Annual)',
        key: 'calc'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
    // height: 70px;
    padding: 20px;
    background-color: #34c0be;
    display: flex;
}

.heading_new {
    font-family: Montserrat;
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
}

.left {
    border: solid white;
    border-width: 0 2px 2px 0;
    padding: 5px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-top: 9px;
    margin-right: 20px;
}
</style>
